import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "./axiosConfig";
import { useAuth } from "../../AuthContext";

const LinkedinCallback = () => {

  const navigate = useNavigate();

  const { login } = useAuth();

  useEffect(() => {

    const params = new URLSearchParams(
      window.location.search
    );

    const code = params.get("code");

    const state = params.get("state");

    const savedState = localStorage.getItem(
      "linkedin_oauth_state"
    );

    // CSRF protection
    if (state !== savedState) {
      console.error("Invalid LinkedIn state");
      return;
    }

    if (code) {

      api.post("/linkedin-login/", { code })

        .then((res) => {

          const {
            access,
            refresh,
            user_id,
            role,
            roles
          } = res.data;

          // Save tokens
          localStorage.setItem(
            "access_token",
            access
          );

          localStorage.setItem(
            "refresh_token",
            refresh
          );

          localStorage.setItem(
  "linkedin_data",
  JSON.stringify({
    linkedin_id:
      res.data.linkedin_id,

    profile_picture:
      res.data.profile_picture,

    email:
      res.data.email,
  })
);
          // Login via AuthContext
          login(user_id, role, roles);

          navigate("/", {
            replace: true
          });

        })

        .catch((err) => {
          console.error(
            "LinkedIn login failed",
            err
          );
        });
    }

  }, []);

  return (
    <div
      style={{
        color: "white",
        textAlign: "center",
        marginTop: "100px"
      }}
    >
      Logging in with LinkedIn...
    </div>
  );
};

export default LinkedinCallback;